import { useMemo } from 'react';

import useScopedTeacher from '@/data/hook/shared/useScopedTeacher';
import useScopedUnits from '@/data/hook/shared/useScopedUnits';

export type ScopeFilters = {
  unit?: number;
  teacher?: number;
};

export default function useScopeFilters({ unit, teacher }: ScopeFilters = {}) {
  const scopedTeacher = useScopedTeacher(teacher);
  const scopedUnits = useScopedUnits(unit);

  return useMemo(
    () => ({
      teacherId: scopedTeacher ? [scopedTeacher] : undefined,
      unitId: scopedUnits,
    }),
    [scopedTeacher, scopedUnits],
  );
}
